
import FirstScreen from './FirstScreen/FirstScreen';
import Professions from './Professions/Professions';
import Rule from './Rule/Rule';
import Approach from './Approach/Approach';
import Work from './Work/Work';
import Reviews from './Reviews/Reviews';

const MainContent = () => {


	return (
		<main className='wrapper__main main'>
			<div className="main__container">
				<FirstScreen />
				<Professions id="section1" />
				<Rule id="section2" />
				<Approach id="section3" />
				<Work id="section4" />
				<Reviews id="section5" />
			</div>
		</main>
	)

}

export default MainContent;